import React from 'react';

const Milestones = () => {
  return (
    <div className="bg-gray-50 flex min-h-screen items-center justify-center p-6">
      <div className="max-w-4xl rounded-lg bg-white p-8">
        <h1 className="mb-4 text-center text-4xl font-bold text-blue-700">
          NCMRWF: Supercomputing Milestones
        </h1>
        <p className="text-gray-700 text-lg leading-relaxed">
          The journey of <strong className="text-gray-900">NCMRWF</strong> in{' '}
          <span className="font-semibold text-green-600">
            Numerical Weather Prediction (NWP)
          </span>{' '}
          began with the acquisition of the{' '}
          <span className="font-semibold text-blue-600">Cray XMP-14</span> in
          1988, marking its entry into high-performance computing.
        </p>

        <div className="mt-6 space-y-6">
          <div className="relative border-l-4 border-blue-600 p-6">
            <div className="absolute -left-2.5 h-5 w-5 rounded-full bg-blue-600"></div>
            <h2 className="text-gray-900 text-xl font-semibold">
              Inauguration of HPC System (1989)
            </h2>
            <p className="text-gray-700">
              The Cray XMP-14 was installed and officially inaugurated on March
              25, 1989, enabling medium-range NWP.
            </p>
          </div>

          <div className="relative border-l-4 border-blue-600 p-6">
            <div className="absolute -left-2.5 h-5 w-5 rounded-full bg-blue-600"></div>
            <h2 className="text-gray-900 text-xl font-semibold">
              Expansion with Indigenous Supercomputers (1999)
            </h2>
            <p className="text-gray-700">
              Acquired India's parallel processing systems: Anupam-Alpha (BARC)
              & PARAM-10000 (C-DAC), along with Origin-200.
            </p>
          </div>

          <div className="relative border-l-4 border-blue-600 p-6">
            <div className="absolute -left-2.5 h-5 w-5 rounded-full bg-blue-600"></div>
            <h2 className="text-gray-900 text-xl font-semibold">
              Major Supercomputing Upgrades (2001-2015)
            </h2>
            <p className="text-gray-700">
              Installed Cray SV1 (24 processors) in 2001, Cray C1e (64
              processors) in 2006, and Bhaskara (IBM iDataPlex) in 2015.
            </p>
          </div>

          <div className="relative border-l-4 border-green-600 p-6">
            <div className="absolute -left-2.5 h-5 w-5 rounded-full bg-green-600"></div>
            <h2 className="text-gray-900 text-xl font-semibold">
              Mihir Supercomputer (2018)
            </h2>
            <p className="text-gray-700">
              Introduced Mihir, a Cray-XC40 with 2.8 PetaFLOPS, supporting
              high-resolution NWP and data assimilation.
            </p>
          </div>

          <div className="border-red-600 relative border-l-4 p-6">
            <div className="bg-red-600 absolute -left-2.5 h-5 w-5 rounded-full"></div>
            <h2 className="text-gray-900 text-xl font-semibold">
              Arunika: The major milestone (2024)
            </h2>
            <p className="text-gray-700">
              On September 27, 2024, Hon'ble Prime Minister of India inaugurated
              Arunika, an 8.24 PetaFLOPS HPC with 24 PetaBytes storage,
              enhancing extreme weather forecasting.
            </p>
          </div>
        </div>

        {/* <div className="mt-8 flex justify-center">
          <button className="rounded-lg bg-blue-600 px-6 py-3 text-lg font-semibold text-white shadow-md transition-all hover:bg-blue-700">
            Learn More
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Milestones;
